import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Button, Avatar, Divider, Popover, TextField, Modal, OutlinedInput, InputLabel, FormControl } from '@mui/material';
import { FaRegCalendarAlt } from 'react-icons/fa';
import Navbar from '../Navbar';
import ReleaseNote from '../ReleaseNote';
import Alerts from '../Alert';
import LoadScreen from '../Loader';
import config from '../../config';
import { getAvatarUrl } from '../../utils/getAvatarUrl';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import setCookie from '../../hooks/setCookie';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import axios from '../../hooks/fetchWithAuth';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import ConfirmationDialog from '../Confirmation';
import getCookie from '../../hooks/getCookie';
import deleteCookie from '../../hooks/getCookie';
import deleteSession from '../../hooks/deleteSession';

const ouMapping = {
    TI: "TI",
    COMUNICACAO: "COMUNICAÇÃO",
    ESCRITORIOS: "ESCRITÓRIOS",
    "CALL CENTER": "CALL CENTER",
    ESTOQUE: "ESTOQUE",
    OPERACIONAL: "OPERACIONAL",
    ENGENHARIA: "ENGENHARIA",
    CGR: "CGR",
    FROTA: "FROTA",
    RECEPCAO: "RECEPÇÃO",
    PORTARIA: "PORTARIA",
    RH: "RH",
    LOGISTICA: "LOGÍSTICA",
    ADMINISTRATIVO: "ADMINISTRATIVO",
    CORPORATIVO: "CORPORATIVO",
    JURIDICO: "JURÍDICO",
    DESENVOLVIMENTO: "DESENVOLVIMENTO",
    PROJETOS: "PROJETOS",
    PATRIMONIO: "PATRIMÔNIO",
};

const getTextColor = (hexColor) => {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000' : '#fff';
};

const DiretoriaBoards = ({ handleSaveBoard, handleAddLabel, handleDeleteLabel }) => {
    const [boardsByOu, setBoardsByOu] = useState({});
    const [loading, setLoading] = useState(true);
    const [time, setTime] = useState([]);
    const [labels, setLabels] = useState([]);
    const [boardMembers, setBoardMembers] = useState({});
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentBoard, setCurrentBoard] = useState(null);
    const [labelModalOpen, setLabelModalOpen] = useState(false);
    const [addBoardModalOpen, setAddBoardModalOpen] = useState(false);
    const [boardName, setBoardName] = useState('');
    const [boardDescription, setBoardDescription] = useState('');
    const [btnLoading, setBtnLoading] = useState(false);
    const [popoverType, setPopoverType] = useState('');
    const [labelName, setLabelName] = useState('');
    const [labelColor, setLabelColor] = useState('#000000');
    const [editPopoverAnchorEl, setEditPopoverAnchorEl] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [newTitle, setNewTitle] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [labelPopoverAnchorEl, setLabelPopoverAnchorEl] = useState(null);
    const [labelPopoverBoardId, setLabelPopoverBoardId] = useState(null);


    const navigate = useNavigate();

    const currentDate = new Date().toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    useEffect(() => {


        const fetchTime = async () => {
            try {
                const res2 = await fetch(`${config.backend_ip}/api/board/ti/all_users`);
                setTime(await res2.json());
            } catch {
                setTime([]);
            }
        };
        const fetchAllBoardMembers = async () => {
            try {
                const response = await fetch(`${config.backend_ip}/api/board/ti/list_all_members`, { method: 'PUT' });
                const data = await response.json();
                setBoardMembers(data || {}); // Garante que boardMembers nunca seja undefined
                console.log('Board Members:', data);
            } catch (error) {
                setBoardMembers({}); // fallback para objeto vazio
            }
        };


        fetchAllBoardMembers();
        fetchAllBoards();
        fetchTime();
    }, []);

    const userId = getCookie('userId');

    const fetchAllBoards = async () => {
        try {
            setLoading(true);
            //user_id como query param
            const boardsRes = await fetch(`${config.backend_ip}/api/board/ti/all_boards?user_id=${userId}`);
            const boards = await boardsRes.json();
            // Busca etiquetas para cada board
            const boardsWithLabels = await Promise.all(
                boards.map(async (board) => {
                    try {
                        const labelsRes = await fetch(`${config.backend_ip}/api/board/ti/list_tags_in_board?board_id=${board.board_id}`);
                        board.labels = await labelsRes.json();
                    } catch {
                        board.labels = [];
                    }
                    return board;
                })
            );
            const grouped = {};
            boardsWithLabels.forEach(board => {
                const ou = board.ou || 'OUTROS';
                if (!grouped[ou]) grouped[ou] = [];
                grouped[ou].push(board);
            });
            setBoardsByOu(grouped);
        } catch (error) {
            setBoardsByOu({});
        } finally {
            setLoading(false);
        }
    };

    const encryptData = (data) => {
        return CryptoJS.AES.encrypt(data, 'secret-key').toString();
    };

    const handleEnterBoard = (board_id, permissao) => {
        localStorage.removeItem('boardId');
        localStorage.setItem('boardId', board_id);
        setCookie("boardId", board_id);
        localStorage.removeItem('permissao');
        localStorage.setItem('permissao', encryptData(permissao));
        setCookie("permissao", permissao);
        navigate(`/board/${board_id}`);
        localStorage.removeItem('boardTitle');
        const allBoards = Object.values(boardsByOu).flat();
        const board = allBoards.find(board => board.board_id === board_id);
        localStorage.setItem('boardTitle', board?.board_name || '');
        setCookie("boardTitle", board?.board_name || '');
    };

    const handleAddBoardClick = () => {
        setAddBoardModalOpen(true);
    };

    const handleAddBoardClose = () => {
        setAddBoardModalOpen(false);
        setBoardName('');
        setBoardDescription('');
        setPopoverType('');
        setAnchorEl(null);
    };

    const handleLabelModalOpen = () => {
        setLabelModalOpen(true);
    };

    const handleLabelModalClose = () => {
        setLabelModalOpen(false);
        setLabelName('');
        setLabelColor('#000000');
    };

    // Adicione esta função para passar nome e descrição
    const handleSaveBoardInternal = async () => {
        if (boardName.trim()) {
            await handleSaveBoard(boardName, boardDescription);
            setAddBoardModalOpen(false);
            setBoardName('');
            setBoardDescription('');
            fetchAllBoards();
        }
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
        setPopoverType('');
    };
    const handleEditPopoverOpen = (event, board) => {
        setEditPopoverAnchorEl(event.currentTarget);
        setCurrentBoard(board);
    };
    const handleEditPopoverClose = () => {
        setEditPopoverAnchorEl(null);
        setIsEditing(false);
        setNewTitle('');
        setNewDescription('');
        setCurrentBoard(null);
    };
    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleTitleChange = (event) => {
        setNewTitle(event.target.value);
    };
    const handleDescriptionChange = (event) => {
        setNewDescription(event.target.value);
    };
    const handleTitleSubmit = async () => {
        if (!newTitle.trim() && !newDescription.trim()) {
            setIsEditing(false);
            handleEditPopoverClose();
            return;
        }
        try {
            const payload = { board_id: currentBoard.board_id };
            if (newTitle.trim() !== '') {
                payload.board_name = newTitle;
            }
            if (newDescription.trim() !== '') {
                payload.board_description = newDescription;
            }
            await axios.put(`${config.backend_ip}/api/board/ti/update_board`, payload);
            await fetchAllBoards();
        } catch (error) {
            // handle error
        } finally {
            setIsEditing(false);
            handleEditPopoverClose();
        }
    };
    const handleDeleteBoard = async () => {
        try {
            await axios.put(`${config.backend_ip}/api/board/ti/delete_board`, {
                board_id: currentBoard.board_id,
            });
            setDialogOpen(false);
            await fetchAllBoards();
        } catch (error) {
            // handle error
        } finally {
            handleEditPopoverClose();
        }
    };
    const handleSetTagOnBoard = async (boardId, tagId) => {
        try {
            await axios.put(`${config.backend_ip}/api/board/ti/set_tag_on_board`, {
                board_id: boardId,
                tag_id: tagId,
            });
            setLabelPopoverAnchorEl(null);
            setLabelPopoverBoardId(null);
            await fetchAllBoards();
        } catch (error) {
            // handle error
        }
    };
    const handleRemoveTagFromBoard = async (boardId, tagId) => {
        try {
            await axios.put(`${config.backend_ip}/api/board/ti/remove_tag_board`, {
                board_id: boardId,
                tag_id: tagId,
            });
            setLabelPopoverAnchorEl(null);
            setLabelPopoverBoardId(null);
            await fetchAllBoards();
        } catch (error) {
            // handle error
        }
    };

    const fetchLabels = async () => {
        try {
            const response = await axios.get(`${config.backend_ip}/api/board/ti/list_tags_boards`, {
                params: { ou: 'DIRETORIA' },
            });
            setLabels(response.data);
        } catch (error) {
            setLabels([]);
        }
    };

    useEffect(() => {
        fetchLabels();
    }, []);

    const handleAddLabelInternal = async () => {
        if (labelName.trim()) {
            try {
                await axios.put(`${config.backend_ip}/api/board/ti/create_tag_board`, {
                    color_hex: labelColor,
                    tag_name: labelName,
                    ou: 'DIRETORIA',
                });
                await fetchLabels();
                setLabelName('');
                setLabelColor('#000000');
            } catch (error) {
                // handle error
            }
        }
    };

    const handleDeleteLabelInternal = async (tag_id) => {
        try {
            await axios.put(`${config.backend_ip}/api/board/ti/delete_tag_board`, {
                tag_id: tag_id,
            });
            setLabels(labels.filter((label) => label.tag_id !== tag_id));
        } catch (error) {
            // handle error
        }
    };

    return (
        <>
            <Navbar isHome={true} />
            <ReleaseNote />
            <Box className="container-home">
                {loading ? (
                    <div style={{ width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <LoadScreen />
                    </div>
                ) : (
                    <div style={{ width: '100%', justifyContent: 'flex-start' }}>
                        <Box className="box-container" sx={{ padding: '70px 0px', width: '100%', justifyContent: 'flex-start', height: '100%' }}>
                            {/* Lateral esquerda: Workspace, ações, nosso time */}
                            <Box sx={{ width: 300, p: 4 }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>WORKSPACE<br />DIRETORIA</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 4 }}>
                                    <FaRegCalendarAlt style={{ marginRight: 8 }} />
                                    <Typography variant="body2">{currentDate}</Typography>
                                </Box>
                                <Box sx={{ mt: 4 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>AÇÕES</Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, flexDirection: 'column' }}>
                                        <Button onClick={handleAddBoardClick} className='button-add-board'>Novo Quadro</Button>
                                        <Button onClick={handleLabelModalOpen} className='button-add-board'>Gerenciar Etiquetas</Button>
                                    </Box>
                                </Box>
                                <Box sx={{ mt: 4 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 2 }}>NOSSO TIME</Typography>
                                    <div style={{ maxHeight: '440px', overflowY: 'scroll' }}>
                                        {time
                                            .sort((a, b) => a.nome_completo.localeCompare(b.nome_completo))
                                            .map((member, index) => (
                                                <Box className="nosso-time" key={index} sx={{ display: 'flex', alignItems: 'center', mb: 2, p: 1, bgcolor: 'white', borderRadius: 2 }}>
                                                    <Avatar src={getAvatarUrl(member.Nome)} />
                                                    <Box sx={{ ml: 2 }}>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{member.nome_completo} - {member.ou}</Typography>
                                                        <Typography variant="caption">{member.Nome} </Typography>
                                                    </Box>
                                                </Box>
                                            ))}
                                    </div>
                                </Box>
                            </Box>
                            {/* Direita: Quadros por setor, layout igual Home */}
                            <Box sx={{ flex: 1, padding: '32px 80px', maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>Quadros por Setor</Typography>
                                {Object.keys(boardsByOu).sort().map(ouKey => (
                                    <Box key={ouKey} sx={{ mb: 6 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                                            {ouMapping[ouKey] || ouKey}
                                        </Typography>
                                        <Divider sx={{ mb: 2 }} />
                                        <Box className="scrollable-container" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'flex-start' }}>
                                            {ouKey === 'DIRETORIA' ? (
                                                boardsByOu[ouKey].map(board => (
                                                    <React.Fragment key={board.board_id}>
                                                        <Box
                                                            className="board-card"
                                                            sx={{ borderRadius: 2, p: 2, mb: 2, boxShadow: 1 }}
                                                            onClick={() => {
                                                                if (!anchorEl) {
                                                                    handleEnterBoard(board.board_id, board.permissao);
                                                                }
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                                                    {board.labels?.map((label, index) => (
                                                                        <Box
                                                                            key={index}
                                                                            className="etiqueta-board"
                                                                            sx={{
                                                                                backgroundColor: label.color_hex,
                                                                                color: getTextColor(label.color_hex),
                                                                                padding: '6px 10px',
                                                                                borderRadius: '4px',
                                                                            }}
                                                                        >
                                                                            {label.tag_name}
                                                                        </Box>
                                                                    ))}
                                                                    <Box
                                                                        className="add-label"
                                                                        onClick={(event) => {
                                                                            event.stopPropagation();
                                                                            setLabelPopoverAnchorEl(event.currentTarget);
                                                                            setLabelPopoverBoardId(board.board_id);
                                                                            setCurrentBoard(board);
                                                                        }}
                                                                    >
                                                                        +
                                                                    </Box>
                                                                </Box>
                                                                <Popover
                                                                    open={Boolean(labelPopoverAnchorEl) && labelPopoverBoardId === board.board_id}
                                                                    anchorEl={labelPopoverAnchorEl}
                                                                    onClose={() => {
                                                                        setLabelPopoverAnchorEl(null);
                                                                        setLabelPopoverBoardId(null);
                                                                    }}
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'center',
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'center',
                                                                    }}
                                                                    PaperProps={{
                                                                        sx: { p: 3, width: 250 },
                                                                        className: 'popover-content',
                                                                    }}
                                                                >
                                                                    <Typography variant="subtitle1" sx={{ mb: 2, fontSize: '20px' }}>Gerenciar Etiquetas</Typography>
                                                                    {labels.map((label) => {
                                                                        const isLabelOnBoard = board.labels?.some((boardLabel) => boardLabel.tag_id === label.tag_id) || false;
                                                                        return (
                                                                            <Box
                                                                                key={label.tag_id}
                                                                                sx={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'space-between',
                                                                                    mb: 2,
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            >
                                                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <Box
                                                                                        sx={{
                                                                                            width: '60px',
                                                                                            height: 16,
                                                                                            backgroundColor: label.color_hex,
                                                                                            borderRadius: '5px',
                                                                                            mr: 2,
                                                                                        }}
                                                                                    />
                                                                                    <Typography variant="body2">{label.tag_name}</Typography>
                                                                                </Box>
                                                                                {isLabelOnBoard ? (
                                                                                    <CloseRoundedIcon
                                                                                        sx={{ color: 'red', cursor: 'pointer', ml: 2, fontSize: '20px' }}
                                                                                        onClick={(event) => {
                                                                                            event.stopPropagation();
                                                                                            handleRemoveTagFromBoard(board.board_id, label.tag_id);
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <AddRoundedIcon
                                                                                        sx={{ color: 'green', cursor: 'pointer', ml: 2, fontSize: '20px' }}
                                                                                        onClick={(event) => {
                                                                                            event.stopPropagation();
                                                                                            handleSetTagOnBoard(board.board_id, label.tag_id);
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </Box>
                                                                        );
                                                                    })}
                                                                </Popover>
                                                                <MoreVertIcon
                                                                    className="icon-board"
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        handleEditPopoverOpen(event, board);
                                                                    }}
                                                                />
                                                            </div>
                                                            <Typography variant="body2" sx={{ fontWeight: 'bold', mt: 1 }}>{board.board_name}</Typography>
                                                            <Typography variant="caption" sx={{ mt: 1, color: '#888' }}>{board.board_description}</Typography>
                                                            <div style={{ width: '100%', justifyContent: 'flex-end', display: 'flex' }}>
                                                                <Box sx={{ display: 'flex', mt: 1, justifyContent: 'flex-end', maxWidth: '230px', flexWrap: 'wrap', gap: '10px' }}>
                                                                    
                                                                    {(boardMembers && boardMembers[board.board_id]) ? boardMembers[board.board_id].map((boardMember, index) => {
                                                                        const matchedMember = time.find(
                                                                            (member) => parseInt(member.userId) === parseInt(boardMember.user_id)
                                                                        );
                                                                        return matchedMember ? (
                                                                            <Avatar
                                                                                key={index}
                                                                                src={getAvatarUrl(matchedMember.Nome)}
                                                                                sx={{ width: 24, height: 24, ml: -1 }}
                                                                                title={matchedMember.nome_completo}
                                                                            />
                                                                        ) : null;
                                                                    }) : null}
                                                                </Box>
                                                            </div>
                                                        </Box>
                                                        <Popover
                                                            open={Boolean(editPopoverAnchorEl) && popoverType === ''}
                                                            anchorEl={editPopoverAnchorEl}
                                                            onClose={handleEditPopoverClose}
                                                            anchorOrigin={{
                                                                vertical: 'bottom',
                                                                horizontal: 'center',
                                                            }}
                                                            transformOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'center',
                                                            }}
                                                            PaperProps={{
                                                                className: 'popover-content',
                                                                sx: {
                                                                    zIndex: 2,
                                                                },
                                                            }}
                                                        >
                                                            {isEditing ? (
                                                                <Box style={{ display: 'flex', flexDirection: 'column', padding: '20px', gap: '10px' }}>
                                                                    <Typography className="popover-title">Editar Quadro</Typography>
                                                                    <TextField
                                                                        value={newTitle || (currentBoard ? currentBoard.board_name : '')}
                                                                        onChange={handleTitleChange}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        sx={{
                                                                            width: '250px',
                                                                            marginRight: '10px',
                                                                            '& .MuiOutlinedInput-root': {
                                                                                backgroundColor: 'var(--textfield-bg-color, #fff)',
                                                                                color: 'var(--textfield-text-color, #000)',
                                                                                '& fieldset': {
                                                                                    borderColor: 'var(--textfield-border-color, #ccc)',
                                                                                },
                                                                                '&:hover fieldset': {
                                                                                    borderColor: 'var(--textfield-hover-border-color, #aaa)',
                                                                                },
                                                                                '&.Mui-focused fieldset': {
                                                                                    borderColor: 'var(--textfield-focus-border-color, #009373)',
                                                                                },
                                                                            },
                                                                            '& .MuiInputLabel-root': {
                                                                                color: 'var(--textfield-label-color, #000)',
                                                                            },
                                                                            '& .Mui-focused .MuiInputLabel-root': {
                                                                                color: 'var(--textfield-label-focus-color, #009373)',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                color: 'var(--textfield-text-color, #000)',
                                                                            },
                                                                        }}
                                                                    />
                                                                    <TextField
                                                                        value={newDescription || (currentBoard ? currentBoard.board_description : '')}
                                                                        onChange={handleDescriptionChange}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        sx={{
                                                                            width: '250px',
                                                                            marginRight: '10px',
                                                                            '& .MuiOutlinedInput-root': {
                                                                                backgroundColor: 'var(--textfield-bg-color, #fff)',
                                                                                color: 'var(--textfield-text-color, #000)',
                                                                                '& fieldset': {
                                                                                    borderColor: 'var(--textfield-border-color, #ccc)',
                                                                                },
                                                                                '&:hover fieldset': {
                                                                                    borderColor: 'var(--textfield-hover-border-color, #aaa)',
                                                                                },
                                                                                '&.Mui-focused fieldset': {
                                                                                    borderColor: 'var(--textfield-focus-border-color, #009373)',
                                                                                },
                                                                            },
                                                                            '& .MuiInputLabel-root': {
                                                                                color: 'var(--textfield-label-color, #000)',
                                                                            },
                                                                            '& .Mui-focused .MuiInputLabel-root': {
                                                                                color: 'var(--textfield-label-focus-color, #009373)',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                color: 'var(--textfield-text-color, #000)',
                                                                            },
                                                                        }}
                                                                    />
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={handleTitleSubmit}
                                                                        className='button-edit-board'
                                                                        style={{ marginRight: '10px', width: '100%', height: '35px', display: 'block', marginTop: '10px' }}
                                                                    >
                                                                        Salvar
                                                                    </Button>
                                                                </Box>
                                                            ) : (
                                                                <Box>
                                                                    <Typography
                                                                        className="popover-option"
                                                                        sx={{ mb: 1 }}
                                                                        onClick={handleEditClick}
                                                                    >
                                                                        Editar Quadro
                                                                    </Typography>
                                                                    <Typography
                                                                        className="popover-option"
                                                                        sx={{ color: 'red' }}
                                                                        onClick={() => setDialogOpen(true)}
                                                                    >
                                                                        Excluir Quadro
                                                                    </Typography>
                                                                    <ConfirmationDialog
                                                                        open={dialogOpen}
                                                                        onClose={() => setDialogOpen(false)}
                                                                        onConfirm={handleDeleteBoard}
                                                                        title="Confirmar Exclusão"
                                                                        message="Tem certeza de que deseja excluir o quadro? Esta ação não pode ser desfeita."
                                                                    />
                                                                </Box>
                                                            )}
                                                        </Popover>
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                boardsByOu[ouKey].map(board => (
                                                    <Box
                                                        key={board.board_id}
                                                        className="board-card"
                                                        sx={{ borderRadius: 2, p: 2, mb: 2, boxShadow: 1 }}
                                                        onClick={() => {
                                                            if (!anchorEl) {
                                                                handleEnterBoard(board.board_id, board.permissao);
                                                            }
                                                        }}
                                                    >
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                                            {board.labels?.map((label, index) => (
                                                                <Box
                                                                    key={index}
                                                                    className="etiqueta-board"
                                                                    sx={{
                                                                        backgroundColor: label.color_hex,
                                                                        color: getTextColor(label.color_hex),
                                                                        padding: '6px 10px',
                                                                        borderRadius: '4px',
                                                                    }}
                                                                >
                                                                    {label.tag_name}
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold', mt: 1 }}>{board.board_name}</Typography>
                                                        <Typography variant="caption" sx={{ mt: 1, color: '#888' }}>{board.board_description}</Typography>
                                                        <div style={{ width: '100%', justifyContent: 'flex-end', display: 'flex' }}>
                                                            <Box sx={{ display: 'flex', mt: 1, justifyContent: 'flex-end', maxWidth: '230px', flexWrap: 'wrap', gap: '10px' }}>
                                                                {(boardMembers && boardMembers[board.board_id]) ? boardMembers[board.board_id].map((boardMember, index) => {
                                                                    const matchedMember = time.find(
                                                                        (member) => parseInt(member.userId) === parseInt(boardMember.user_id)
                                                                    );
                                                                    return matchedMember ? (
                                                                        <Avatar
                                                                            key={index}
                                                                            src={getAvatarUrl(matchedMember.Nome)}
                                                                            sx={{ width: 24, height: 24, ml: -1 }}
                                                                            title={matchedMember.nome_completo}
                                                                        />
                                                                    ) : null;
                                                                }) : null}
                                                            </Box>
                                                        </div>
                                                    </Box>
                                                ))
                                            )}
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </div>
                )}
            </Box>
            {/* MODAL ADICIONAR NOVO QUADRO */}
            <Modal
                open={addBoardModalOpen}
                onClose={handleAddBoardClose}
                aria-labelledby="add-board-modal-title"
                aria-describedby="add-board-modal-description"
            >
                <Box
                    className="add-board-modal"
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: '5px',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography id="add-board-modal-title" variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>Adicionar novo quadro</Typography>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel htmlFor="board-name-input">Nome do Quadro*</InputLabel>
                        <OutlinedInput
                            id="board-name-input"
                            label="Nome do Quadro*"
                            value={boardName}
                            onChange={(e) => setBoardName(e.target.value)}
                            sx={{
                                borderRadius: '4px',
                                backgroundColor: 'var(--textfield-bg-color, #f8f8f8)',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'var(--textfield-border-color, #ccc)',
                                    borderRadius: '4px',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#009373',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#009373',
                                },
                                color: 'var(--textfield-text-color, #222)',
                            }}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel htmlFor="board-description-input">Descrição</InputLabel>
                        <OutlinedInput
                            id="board-description-input"
                            label="Descrição"
                            value={boardDescription}
                            onChange={(e) => setBoardDescription(e.target.value)}
                            multiline
                            rows={2}
                            sx={{
                                borderRadius: '4px',
                                backgroundColor: 'var(--textfield-bg-color, #f8f8f8)',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'var(--textfield-border-color, #ccc)',
                                    borderRadius: '4px',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#009373',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#009373',
                                },
                                color: 'var(--textfield-text-color, #222)',
                            }}
                        />
                    </FormControl>
                    <Button
                        variant="contained"
                        onClick={handleSaveBoardInternal}
                        disabled={btnLoading}
                        className='add-board-modal-button'
                        sx={{ width: '100%', height: '40px', fontWeight: 'bold', fontSize: '16px' }}
                    >
                        {btnLoading ? <CircularProgress size={24} color="inherit" /> : 'Criar Quadro'}
                    </Button>
                </Box>
            </Modal>
            {/* MODAL GERENCIAR ETIQUETAS */}
            <Modal
                open={labelModalOpen}
                onClose={handleLabelModalClose}
                aria-labelledby="label-modal-title"
                aria-describedby="label-modal-description"
            >
                <Box
                    className="label-modal"
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 500,
                        bgcolor: 'background.paper',
                        borderRadius: '5px',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography id="label-modal-title" variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>Gerenciar Etiquetas</Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="label-name-input">Nome da Etiqueta</InputLabel>
                            <OutlinedInput
                                id="label-name-input"
                                label="Nome da Etiqueta"
                                value={labelName}
                                onChange={(e) => setLabelName(e.target.value)}
                                sx={{
                                    borderRadius: '4px',
                                    backgroundColor: 'var(--textfield-bg-color, #f8f8f8)',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'var(--textfield-border-color, #ccc)',
                                        borderRadius: '4px',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#009373',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#009373',
                                    },
                                    color: 'var(--textfield-text-color, #222)',
                                }}
                            />
                        </FormControl>
                        <p>Cor:</p>
                        <FormControl sx={{ width: 70, minWidth: 70 }}>
                            <OutlinedInput
                                type="color"
                                value={labelColor}
                                onChange={(e) => setLabelColor(e.target.value)}
                                sx={{
                                    borderRadius: '4px',
                                    backgroundColor: 'var(--textfield-bg-color, #f8f8f8)',
                                    padding: 0,
                                    height: '53px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'var(--textfield-border-color, #ccc)',
                                        borderRadius: '4px',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#009373',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#009373',
                                    },
                                }}
                            />
                        </FormControl>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={handleAddLabelInternal}
                        className="label-button"
                        sx={{ width: '100%', mb: 2, fontWeight: 'bold', fontSize: '15px' }}
                    >
                        Adicionar Etiqueta
                    </Button>
                    <Box sx={{ mt: 2, maxHeight: '250px', overflowY: 'auto' }}>
                        {labels.map((label, index) => (
                            <Box key={index} className="label-item" sx={{ display: 'flex', alignItems: 'center', mb: 1, p: 1, borderRadius: 2, bgcolor: 'background.default' }}>
                                <Box
                                    className="label-color"
                                    sx={{ backgroundColor: label.color_hex, width: 60, height: 24, borderRadius: 2, mr: 2 }}
                                />
                                <Typography variant="body2" sx={{ flex: 1, fontSize: '16px', fontWeight: 'bold' }}>{label.tag_name}</Typography>
                                <DeleteRoundedIcon
                                    className="label-delete"
                                    onClick={() => handleDeleteLabelInternal(label.tag_id)}
                                    sx={{ color: 'red', cursor: 'pointer', ml: 2 }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default DiretoriaBoards;
